import Link from "next/link";
import styles from "./CampaignRow.module.scss";
import {Typography} from "antd";
import striptags from "striptags";
import Image from "grandus-lib/components-atomic/image/Image";

const CampaignRow = ({ photo, name, urlName, description }) => (
    <Link href="/akcie/[campaign]/[[...parameters]]" as={`/akcie/${urlName}`}>
        <a className={`${styles.row}`}>
            {photo ? (
                <div className={`image ${styles?.photo}`}>
                    <Image photo={photo} size="80x80__cropped" type="jpg" />
                </div>
            ) : (
                ""
            )}
            <div className={styles?.right}>
                <h4>{name}</h4>
                {description ? (
                    <Typography.Paragraph ellipsis={{ rows: 2 }}>
                        <div dangerouslySetInnerHTML={{ __html: striptags(description) }} />
                    </Typography.Paragraph>
                ) : null}
            </div>
        </a>
    </Link>
);

export default CampaignRow;
